export class product_detail_operational_information_duration {
  public days: number = 0;
  public hours: number = 0;
  public minutes: number = 0;
}
